export default __webpack_public_path__ + "static/media/litIt.2214dc6d.jpg";